import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type { Id } from 'types';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export async function resendInvitationFn(
  axiosInstance: Promise<AxiosInstance>,
  { userId }: { userId: Id },
) {
  const instance = await axiosInstance;
  return instance.put(`send_invitations/${userId}`);
}

export function useResendInvitation() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, Id>({
    mutationFn: userId => resendInvitationFn(axiosInstance, { userId }),
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: ['users'],
      });
    },
  });

  return addActionNameToMutationResult<ApiResponse, ApiError, Id, 'resendInvitation'>(
    'resendInvitation',
    mutation,
  );
}
